// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"23dd8b73","515":"2a1555f6","588":"a785dcbb","593":"07dbc2c7","797":"b59b263b"}[chunkId] + ".chunk.js";
};